import { render, staticRenderFns } from "./CourseComponent.vue?vue&type=template&id=2c7c98f0&scoped=true&"
import script from "./CourseComponent.vue?vue&type=script&lang=js&"
export * from "./CourseComponent.vue?vue&type=script&lang=js&"
import style0 from "./CourseComponent.vue?vue&type=style&index=0&id=2c7c98f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7c98f0",
  null
  
)

export default component.exports